import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Paragraph, Table } from 'components/patterns'
import { TextArea } from 'components/deprecated/Inputs'

export const NotesTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  color: ${themeColor('black')};
`

export const TemplateName = styled(Paragraph)`
  font-size: 20px;
  margin-bottom: 15px;
  color: ${themeColor('black')};
`

export const Description = styled(Paragraph)`
  margin-bottom: 0;
  color: ${themeColor('blackPrimary')};
`

export const StyledFragmentList = styled.ul`
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;
  text-align: left;
  color: ${themeColor('blackPrimary')};
`

export const StyledData = styled.span`
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: ${themeColor('blackPrimary')};
`

export const DataItem = styled.span`
  margin-left: 8px;
  margin-right: 8px;
`

export const TextInputContainer = styled.div`
  position: absolute;
  width: 500px;
  height: 75px;
`

export const StyledParagraphThree = styled(Paragraph)``

export const StyledTextArea = styled(TextArea)`
  textarea.ant-input {
    height: 150px;
    min-height: 150px;
    width: 600px !important;
  }
  .input-footer.input-footer {
    margin-left: 570px;
  }
`

export const StyledTable = styled(Table)`
  width: 100%;
  margin-top: -16px;
  .ant-table-body {
    overflow-x: hidden !important;
  }
  .ant-table-header {
    padding-right: 16px !important;
    background-color: ${themeColor('greySecondary')};
  }
`
export const TableSubTitle = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${themeColor('blackSecondary')};
  margin-bottom: 2px;
  display: block;
`
